import React from "react";
import Amenities from "../components/Amenities/Amenities";
import ReactDOM from "react-dom";
import getRowData from "../assets/store/getRowData";
import { getDefaultFontFamily } from "../assets/store/getDefaultFontFamily";

const renderAmenities = () => {
    const rows = document.getElementsByClassName("ds-amenities-section-row");
    const drive_service_divs = window.DriveServiceSpecials.drive_service_divs;
    const oems = window.DriveServiceSpecials.oems;
    const { client } = window.DriveServiceSpecials;
    const { default_oem, links } = client;
    const defaultFontFamily = getDefaultFontFamily({
        fontFamily: client?.font_family,
    });

    for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        const parent = drive_service_divs.find(
            (div) =>
                div.id === parseInt(row.parentElement.id.replace("ds-div-", ""))
        );
        let rowData = getRowData(parent.div_rows, parseInt(row.id));
        const { amenities_section } = rowData;
        const { amenities_theme } = amenities_section;
        const defaultFontFamily = getDefaultFontFamily({
            fontFamily: amenities_theme?.font_family,
        });

        row.style.setProperty(
            "background-color",
            amenities_section.background_color
        );
        const commonDataAttr = {
            "data-divid": parent.id,
            "data-rowid": rowData.id,
            "data-clientid": client.id,
        };

        let amenitiesProps = {
            amenities: amenities_section,
            rowData: rowData,
            oem: default_oem || oems[0] || null,
            links,
            defaultFontFamily,
            dataAttributes: commonDataAttr,
            client,
            theme: amenities_theme,
            isTableRow:
                parent?.div_rows[rowData?.parentRowIndex]?.type === "table_row",
        };
        ReactDOM.render(<Amenities {...amenitiesProps} />, row);
    }
};

if (process.env.REACT_APP_ENVIRONMENT !== "local") renderAmenities();
window.renderAmenities = renderAmenities;

export default renderAmenities;
